import styled, { css } from 'styled-components';

import { formFieldConsts } from '../../FormField.consts';
import { FormFieldSize } from '../../FormField.types';

type CommonStyledProps = {
  size: FormFieldSize;
};

const Container = styled.div<CommonStyledProps>`
  ${({ size }) => css`
    display: flex;
    flex-direction: column;
    margin-bottom: ${formFieldConsts[size].margin};

    svg {
      width: ${formFieldConsts[size].icon};
      height: ${formFieldConsts[size].icon};

      margin-right: 6px;
    }
  `}
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.label<CommonStyledProps>`
  ${({ size, theme }) => css`
    ${size === 'small' && theme.label.small.bold};
    ${size === 'medium' && theme.label.medium.bold};
    color: ${theme.text.onSurface.strong};
  `}
`;

const Mandatory = styled.span<CommonStyledProps>`
  ${({ size, theme }) => css`
    ${size === 'small' && theme.label.small.bold};
    ${size === 'medium' && theme.label.medium.bold};
    color: ${theme.system.strong.negative};
    margin-left: 1px;
  `}
`;

const Description = styled.span`
  ${({ theme }) => css`
    ${theme.label.small.normal};
    color: ${theme.text.onSurface.subtle};
  `}
`;

export { Container, TitleContainer, Title, Mandatory, Description };
